import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES, projectsIn, projectPath } from "@/data/site";
import { FadeUp } from "@/components/Reveal";
import { SectionTitle } from "@/components/SectionTitle";
import { StatusBadge } from "@/components/StatusBadge";

const AreaRow = ({ cat, i }) => (
  <FadeUp delay={(i % 2) * 0.06} className="h-full">
    <article className="grid h-full overflow-hidden border border-gold/40 bg-ivory sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]" data-testid={`estate-area-${cat.slug}`}>
      <Link to={`/${cat.slug}`} className="group relative block min-h-[220px] overflow-hidden">
        <img src={cat.image.src} alt={cat.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-[cubic-bezier(.22,1,.36,1)] group-hover:scale-[1.06]" />
      </Link>
      <div className="p-6 md:p-8">
        <p className="font-caps text-[11px] tracking-[0.3em] text-gold-deep">{cat.numeral}</p>
        <Link to={`/${cat.slug}`} className="mt-1 block font-caps text-xl text-heritage hover:text-gold-deep">{cat.title}</Link>
        <p className="mt-3 text-[16px] leading-relaxed text-muted-ink">{cat.intro}</p>
        <ul className="mt-5 border-t border-gold/30">
          {projectsIn(cat.slug).map((p) => (
            <li key={p.slug}>
              <Link to={projectPath(p)} className="group flex items-center justify-between gap-3 border-b border-gold/20 py-3" data-testid={`estate-project-${p.slug}`}>
                <span className="font-display text-xl text-heritage transition-colors group-hover:text-gold-deep">{p.name}</span>
                <span className="flex shrink-0 items-center gap-2">
                  <StatusBadge status={p.status} />
                  <ArrowUpRight size={16} className="text-gold-deep transition-transform group-hover:rotate-45" />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </article>
  </FadeUp>
);

export const EstateProjects = () => (
  <section className="bg-ivory-muted py-20 lg:py-24" data-testid="estate-projects">
    <div className="mx-auto max-w-[1440px] px-5 md:px-10">
      <FadeUp>
        <SectionTitle eyebrow="The Estate Today" title="Projects Across the Estate">
          Across its coastline, ridge, rainforest and cultivated land, the estate is home to a growing collection of projects in six areas: places to stay, wellness, nature trails, cocoa and fresh water, the sea, and culture. Some already exist, others are being built, and others are still being planned.
        </SectionTitle>
      </FadeUp>
      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        {CATEGORIES.map((c, i) => <AreaRow key={c.slug} cat={c} i={i} />)}
      </div>
    </div>
  </section>
);
